module.exports = __webpack_public_path__ + "static/media/visibility_blue.44f536f5.svg";